import React from 'react';
import { useState, useEffect } from 'react'
import './Principal.css';
import { ShoppingBagIcon } from '@heroicons/react/24/outline'
import ShoppingCarts from '../ShoppingCarts';


function HeaderPrincipal({cart}) {

    const [estado, setEstado] = useState(false)
    const [scrolling, setScrolling] = useState(false);

    const toggleEstado = () =>{
        setEstado(!estado);
    }

    useEffect(() => {
        const handleScroll = () => {
          if (window.scrollY > 0) {
            setScrolling(true);
          } else {
            setScrolling(false);
          }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        // Limpia el evento al desmontar el componente
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const headerClass = scrolling ? 'bg-white border-b border-gray-400' : 'bg-transparent';

    return (
        <header className={`p-4 ease-in-out duration-500 ${headerClass}`}>

            <ShoppingCarts isOpen={estado}/>

            <main className='flex justify-between mx-auto max-w-7xl px-4 sm:static sm:px-6 lg:px-8'>

                <h2 className='text-4xl font-bold tracking-tight text-[#fb8cff] cursor-pointer'>
                    S
                    <sub className='text-4xl font-bold tracking-tight'>B</sub>
                </h2>

                <a onClick={()=>toggleEstado()} class="relative cursor-pointer inline-flex items-center p-3 text-sm font-medium text-center text-white focus:outline-none">
                    <ShoppingBagIcon
                      className="h-6 w-6 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />
                    <div class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full -top-2 -right-2">{cart}</div>
                </a>

            
                {/* <a href="/micarrito">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-shopping-cart" width="35" height="35" viewBox="0 0 24 24" stroke-width="2" stroke="#000" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                        <path d="M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                        <path d="M17 17h-11v-14h-2"></path>
                        <path d="M6 5l14 1l-1 7h-13"></path>
                    </svg>
                    <sub>{cart}</sub>
                </a>  */}
                
            </main>   
            
        </header>
    )
}

export default HeaderPrincipal
